import { QueryClient } from '@tanstack/react-query';

export type { ApiFnReturnType, QueryConfig, MutationConfig } from '@linkie/shared';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});
